import { t, type I18nLocale } from '@ardoq/i18n';
import type { MetamodelEditorLabels } from '@ardoq/metamodel-editor';

export const getMetamodelEditorLabels = (
  i18nLocale: I18nLocale
): MetamodelEditorLabels => ({
  stylePreviewHeader: t(
    i18nLocale,
    'metamodelEditor:stylePreviewHeader',
    'Style Preview'
  ),
  stylePreviewCaption: t(
    i18nLocale,
    'metamodelEditor:stylePreviewCaption',
    'This is how the component type will be displayed. For accessibility and a better experience, the color contrast might be automatically adjusted.'
  ),
  stylePreviewImageAlt: t(
    i18nLocale,
    'metamodelEditor:stylePreviewImageAlt',
    "Image preview of the component's style"
  ),
  createNodePlaceholder: t(
    i18nLocale,
    'metamodelEditor:createNodePlaceholder',
    'Component type'
  ),
  createNodeUnknownError: t(
    i18nLocale,
    'metamodelEditor:createNodeUnknownError',
    'Unknown Error'
  ),
  validationNameEmpty: t(
    i18nLocale,
    'metamodelEditor:validationNameEmpty',
    "Name can't be empty"
  ),
  validationNameTaken: t(
    i18nLocale,
    'metamodelEditor:validationNameTaken',
    'Name is taken'
  ),
  addLeafTooltip: t(
    i18nLocale,
    'metamodelEditor:addLeafTooltip',
    'Add component type'
  ),
  addRootButton: t(
    i18nLocale,
    'metamodelEditor:addRootButton',
    'Add component type'
  ),
});
